module.exports = __webpack_public_path__ + "static/vmware_17.c60525c1.jpg";